/* rr-card-eta.js (7.3, 6 Oct 2026; 8 Oct: store stock only, on the image): works out each
   product card's availability (snippets/rr-card-eta.liquid) with the product page's own engine,
   assets/eta-core.js, and the shared rules in window.RR_CARD_ETA
   (snippets/rr-card-eta-globals.liquid). The pill is the product page's
   badge (RaptorEta.badgeHtml) with its phone chip wording
   (RaptorEta.shortLabel). Cards that arrive later (filters, sorting,
   recommendations, infinite scroll) are filled as they appear. eta-core.js
   is loaded here only when the page has not loaded it already. */
(function () {
  'use strict';
  var G = window.RR_CARD_ETA;
  if (!G) return;
  var doc = document;

  function json(s) {
    if (!s || s === 'null') return null;
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  /* "Pickup today" only while the store can still hand it over today (owner, 8 Oct 2026: pickup
     hours are the store hours). Hours as in assets/rr-store.js (footer, Google listing): Mon, Tue,
     Thu, Fri 11am to 6pm; Wed 11am to 7pm; Sat and Sun closed; plus the Ontario closure days in
     the ETA holiday calendar (custom.eta_holiday_calendar onClosed). Keep these in step.
     America/Toronto time. Before opening on an open day it is still "Pickup today". */
  var HOURS = { 0: null, 1: [11, 18], 2: [11, 18], 3: [11, 19], 4: [11, 18], 5: [11, 18], 6: null };
  function pickupOpenToday() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit',
        weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date(Date.now()))
        .forEach(function (x) { p[x.type] = x.value; });
    } catch (e) { return false; }
    var dow = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[String(p.weekday).slice(0, 3)];
    var h = HOURS[dow], t = (parseInt(p.hour, 10) % 24) + (parseInt(p.minute, 10) || 0) / 60;
    if (!h || t >= h[1]) return false;
    var iso = p.year + '-' + p.month + '-' + p.day;
    var closed = (G.etaCalendar && G.etaCalendar.onClosed) || [];
    for (var i = 0; i !== closed.length; i++) { if (String(closed[i]).slice(0, 10) === iso) return false; }
    return true;
  }
  var OPEN_TODAY = pickupOpenToday();

  function fill(el) {
    if (el.__rrEta) return;
    el.__rrEta = true;
    var E = window.RaptorEta;
    var inv = json(el.getAttribute('data-inv'));
    var r = null;
    try {
      r = E.compute({
        market: G.isUS ? 'US' : 'CA',
        todayTs: Math.floor(Date.now() / 1000),
        etaCalendar: G.etaCalendar,
        t14Cycle: G.t14Cycle,
        inventoryMap: inv ? { locations: inv } : null,
        inventoryVariantId: el.getAttribute('data-v'),
        fulfillmentSources: G.fulfillmentSources,
        warehouseBuffers: G.warehouseBuffers,
        vendorGroups: G.vendorGroups,
        vendorAssignments: G.vendorAssignments,
        vendor: el.getAttribute('data-vendor'),
        turn14: json(el.getAttribute('data-t14')),
        usInStockBuffer: G.usInStockBuffer,
        usOutOfStockBuffer: G.usOutOfStockBuffer,
        manufacturerStockShippingDays: G.manufacturerStockShippingDays
      });
    } catch (e) { r = null; }
    /* 8 Oct 2026 (owner, option A): only our own store stock is shown on cards, on the image's
       top-left corner (the Sale tag is top-right): "Pickup today" when same-day pickup applies and
       the store is open today and not yet closed (pickupOpenToday), else "In store" (owner, 8 Oct:
       "In stock" would also describe distributor stock; this badge is only ever our shelf). Every other state shows nothing on the card; the product page keeps the
       full ship date. Store stock is Canada only, so .com cards carry no badge. */
    el.classList.add('is-empty');
    if (!r || r.badgeState !== 'local') return;
    var card = el.closest ? (el.closest('.product__grid-item') || el.closest('.thumbnail')) : null;
    var img = card ? card.querySelector('.image__container') : null;
    if (!img || img.querySelector('.rr-card-stock')) return;
    var tag = doc.createElement('span');
    tag.className = 'rr-card-stock' + (img.querySelector('.sticker-position-left') ? ' rr-card-stock--right' : '');
    tag.innerHTML = E.badgeHtml('local', r.sameDayPickup && OPEN_TODAY ? 'Pickup today' : 'In store');
    img.classList.add('rr-has-stock');
    img.appendChild(tag);
  }

  function scan(root) {
    [].forEach.call((root || doc).querySelectorAll('[data-rr-card-eta]'), fill);
  }

  function start() {
    scan(doc);
    if (!window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scan(doc); }, 50);
    }).observe(doc.body, { childList: true, subtree: true });
  }

  function ready() {
    if (!doc.querySelector('[data-rr-card-eta]')) {
      /* no cards yet: wait for some to show up before loading anything */
      if (!window.MutationObserver) return;
      var mo = new MutationObserver(function () {
        if (doc.querySelector('[data-rr-card-eta]')) { mo.disconnect(); ready(); }
      });
      mo.observe(doc.body, { childList: true, subtree: true });
      return;
    }
    if (window.RaptorEta && window.RaptorEta.compute) { start(); return; }
    var s = doc.querySelector('script[src*="/eta-core.js"]');
    if (!s) {
      s = doc.createElement('script');
      s.src = G.core;
      s.async = true;
      doc.head.appendChild(s);
    }
    var n = 0;
    (function wait() {
      if (window.RaptorEta && window.RaptorEta.compute) { start(); return; }
      if (++n > 100) return;
      setTimeout(wait, 100);
    })();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
